<template>
  <header
    :class="[
      'w-full sticky top-0 z-50 border-b border-orange-100/50 bg-white/75 shadow-sm backdrop-blur-xl transition-transform duration-300 ease-out',
      isVisible ? 'translate-y-0' : '-translate-y-full'
    ]"
  >
    <div class="absolute top-0 left-0 w-full h-1 bg-[var(--alohin-gradient)]"></div>
    <div class="container mx-auto flex items-center justify-center px-4 py-3 md:px-6 md:py-4">
      <router-link to="/" class="transition-transform duration-300 hover:scale-105">
        <img
          src="@/../public/logo-2.png"
          alt="Logo"
          class="h-auto w-[170px] md:w-[210px]"
        />
      </router-link>
    </div>
  </header>
</template>
<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';

const isVisible = ref(true);

let lastScrollY = 0;

function handleScroll() {
  const currentScrollY = window.scrollY || 0;

  if (currentScrollY <= 16) {
    isVisible.value = true;
    lastScrollY = currentScrollY;
    return;
  }

  isVisible.value = currentScrollY < lastScrollY;
  lastScrollY = currentScrollY;
}

onMounted(() => {
  lastScrollY = window.scrollY || 0;
  window.addEventListener('scroll', handleScroll, { passive: true });
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>
